import { createFileRoute } from '@tanstack/react-router'
import { QuotationPrintPage } from '../../../../features/sales/quotation-print-page'

export const Route = createFileRoute('/_app/quotations/$quotationId/print')({
  staticData: { crumb: 'quotationPrint' },
  component: QuotationPrintPage,
})
